'use client';

import { UTCDate } from '@date-fns/utc';
import { addDays, endOfDay } from 'date-fns';
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import type { SupportedGame } from '@/config/supportedGames';
import { PickemsSectionTitle } from './PickemsSectionTitle';

const UpcomingDailyPickemCard = dynamic(
  () => import('./UpcomingDailyPickemCard'),
  { ssr: false }
);

export const UpcomingPickemsSection = ({ game }: { game: SupportedGame }) => {
  const dates = useMemo(() => {
    const endOfTomorrow = new UTCDate(addDays(endOfDay(new UTCDate()), 1));
    const endOfDayAfterTomorrow = new UTCDate(
      addDays(endOfDay(new UTCDate()), 2)
    );

    return {
      endOfTomorrow,
      endOfDayAfterTomorrow,
    };
  }, []); // Empty dependency array since these calculations don't depend on any props or state

  return (
    <section className="mb-8" id="upcoming-pickems">
      <PickemsSectionTitle>Upcoming daily Pick EM&apos;s</PickemsSectionTitle>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {/* Card #1 for tomorrow */}
        <UpcomingDailyPickemCard date={dates.endOfTomorrow} game={game} />

        {/* Card #2 for the next day */}
        <UpcomingDailyPickemCard
          date={dates.endOfDayAfterTomorrow}
          game={game}
        />
      </div>
    </section>
  );
};
